import {nanoid} from "nanoid"

import App from "@frog/source/models/App.js"
import World from "@frog/source/models/World.js"
import Stage from "@frog/source/models/Stage.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"
import bookScripts from "../scripts.js"

export default {
    "slug": "9",
    "stage": {
        "images": [
            require("./env.png"),
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
            "width": 17,
            "height": 11,
        }),
        "hud": require("../hud.jsx").default,
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    PlotSteps.ReportStartingAnalytics(),
                    // PlotSteps.SpawnPlayerParty({
                    //     "defaultPartyUnitKeys": ["ashe", "kullervo"]
                    // }),
                    "ASHE: A low-level haunting…? I don’t know, I have a weird feeling about this. Maybe Carl has something to say that can help me."
                ]
            },
            ...bookScripts(),
        ]
    },
}
